import { useQuery } from "@tanstack/react-query";
import { getBillingSubscriptionsAction } from "../actions/getBillingSubscriptions.action";
import { IGetBillingSubscriptionsQueryParams } from "../interfaces/billingSubscriptions.interface";

export const BILLING_SUBSCRIPTIONS_QUERY_KEY = "superadmin-billing-subscriptions";

export const useBillingSubscriptionsQuery = ({
  page = 1,
  pageSize = 10,
  order = "DESC",
  orderBy = "expDate",
  clientName,
  status,
}: IGetBillingSubscriptionsQueryParams = {}) => {
  const token = sessionStorage.getItem("token");

  return useQuery({
    queryKey: [BILLING_SUBSCRIPTIONS_QUERY_KEY, page, pageSize, order, orderBy, clientName, status],
    queryFn: () => getBillingSubscriptionsAction({ page, pageSize, order, orderBy, clientName, status }),
    enabled: !!token,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
};
